// ==================== Secret Easter Egg Sequence ====================
/**
 * Secret "ABORT CODE" to unlock alpha game access
 * 
 * Sequence:
 * 1. User clicks LAUNCH button (starts T-5 countdown)
 * 2. During countdown: Click the "A" in "BOARDING SOON" (line 2 of notice box)
 * 3. Then click the RI mission patch logo (before countdown ends)
 * 
 * Success: Countdown aborts, redirects to /game.html
 * Failure: Normal "LAUNCH AUTHORIZATION FAILED" message
 * 
 * Note: No visual feedback during sequence - completely hidden from users
 */

/**
 * Tracks state of the secret abort sequence
 */
interface SecretSequenceState {
    countdownActive: boolean;      // True when T-5 countdown is running
    aClicked: boolean;              // True if "A" was clicked during countdown
    countdownInterval: number | null;  // Interval ID for clearing countdown
}

// Initialize secret sequence state
const secretState: SecretSequenceState = {
    countdownActive: false,
    aClicked: false,
    countdownInterval: null
};

/**
 * Reset the secret sequence to initial state
 * Called when countdown ends or abort sequence completes
 */
function resetSecretSequence(): void {
    secretState.countdownActive = false;
    secretState.aClicked = false;
    if (secretState.countdownInterval !== null) {
        clearInterval(secretState.countdownInterval);
        secretState.countdownInterval = null;
    }
}

/**
 * Start tracking the countdown for secret sequence
 * @param intervalId - The setInterval ID for the countdown timer
 */
function startSecretCountdown(intervalId: number): void {
    secretState.countdownActive = true;
    secretState.aClicked = false;
    secretState.countdownInterval = intervalId;
}

/**
 * Register that the "A" was clicked during countdown
 * Only registers if countdown is active, otherwise does nothing
 */
function registerAClick(): void {
    if (secretState.countdownActive) {
        secretState.aClicked = true;
    }
}

/**
 * Check if patch click completes the abort sequence
 * @returns true if A was clicked first and countdown is still active
 */
function checkPatchForAbort(): boolean {
    return secretState.countdownActive && secretState.aClicked;
}

// ==================== Main Application Logic ====================

// Wait for the DOM to be fully loaded before running scripts
document.addEventListener('DOMContentLoaded', (): void => {
    
    // Get the elements
    const launchBtn = document.getElementById('launchBtn') as HTMLButtonElement | null;
    const secretPatch = document.getElementById('secretPatch') as HTMLImageElement | null;
    const secretA = document.getElementById('secretA') as HTMLSpanElement | null;

    if (!launchBtn) {
        console.error('Launch button not found in DOM');
        return;
    }

    // ==================== Secret Sequence Step 2: "A" Click During Countdown ====================
    if (secretA) {
        secretA.addEventListener('click', (event: MouseEvent): void => {
            event.stopPropagation(); // Prevent event bubbling
            
            // Register A click if countdown is active (no feedback)
            registerAClick();
        });
    }

    // ==================== Secret Sequence Step 3: Patch Click During Countdown (ABORT!) ====================
    if (secretPatch) {
        secretPatch.addEventListener('click', (): void => {
            // Check if this completes the abort sequence
            if (checkPatchForAbort() && launchBtn) {
                // ABORT CODE SUCCESSFUL! Stop the countdown and launch!
                resetSecretSequence();
                
                launchBtn.innerText = "ABORT CODE ACCEPTED";
                
                // Show success and transition to game
                setTimeout((): void => {
                    launchBtn.innerText = "AUTHORIZATION GRANTED";
                    
                    setTimeout((): void => {
                        // Redirect to the alpha game page
                        console.log('🚀 SECRET ALPHA ACCESS GRANTED! Redirecting to game...');
                        window.location.href = '/game.html';
                    }, 1000);
                }, 500);
            }
            // If clicked outside countdown or wrong order, do nothing (silent)
        });
    }

    // ==================== Launch Button: Start Countdown (Step 1) ====================
    launchBtn.addEventListener('click', function(this: HTMLButtonElement): void {
        // Prevent multiple clicks if already counting down or failed
        if (this.classList.contains('pressed') || this.disabled) return;

        // 1. Change visual state to "pressed"
        this.classList.add('pressed'); 
        this.disabled = true; // Disable button

        // 2. Start failure countdown (this starts the secret sequence window)
        let count: number = 5;
        this.innerText = "T-" + count; // Show initial "5" immediately

        const countdownInterval: number = window.setInterval((): void => {
            count--;
            
            if (count > 0) {
                // Show 4, 3, 2, then 1
                launchBtn.innerText = "T-" + count;
            } else {
                // Countdown finished - FAILURE
                clearInterval(countdownInterval);
                launchBtn.innerText = "LAUNCH AUTHORIZATION FAILED";
                resetSecretSequence();
            }
        }, 1000); // Run every 1 second (1000ms)
        
        // Start tracking this countdown for the secret abort sequence
        startSecretCountdown(countdownInterval);
    });

});
